import { Action } from '../actions/action';
import { AutoFinishAction } from '../actions/auto-finish-action';
import { Board } from '../board';
import { GameLogicScore } from '../game-logic-score';
import { PileIdHandler } from '../card/pile-id-handler';
import { PileId } from '../logic-types';
import { Command } from './command';
import { GameLogicDepth } from '../game-logic-depth';

export class AutoFinishMoveCommand implements Command {
  public readonly cardId: string;
  public readonly targetPileId: PileId;

  constructor(cardId: string, targetPileId: PileId) {
    this.cardId = cardId;
    this.targetPileId = targetPileId;
  }

  public serializeToString(): string {
    return `autofinish ${this.cardId} ${PileIdHandler.getStringFromPileId(this.targetPileId)}`;
  }

  public execute(
    board: Board,
    gameLogicScore: GameLogicScore,
    gameLogicDepth: GameLogicDepth,
    actionList: Action[],
  ): boolean {
    const card = board.getCardByCardId(this.cardId);
    const originPile = board.getPileByCardId(this.cardId);
    const targetPile = board.getPileByPileId(this.targetPileId);

    if (originPile === undefined) {
      return false;
    }

    if (!card?.canMove(originPile, targetPile)) {
      return false;
    }

    const action = new AutoFinishAction(this, board, gameLogicDepth, (data) =>
      gameLogicScore.grantPoints(data.card, data.pile),
    );
    action.execute();
    actionList.push(action);

    gameLogicScore.addMove();

    return true;
  }

  public static isCommand(command: Command): command is AutoFinishMoveCommand {
    return command instanceof AutoFinishMoveCommand;
  }
}
